const SCRIPT_ID = "mouseflow-tracking-script";

export const initializeMouseflow = (
  window: Window,
  document: Document,
  siteId: string,
) => {
  window._mfq = window._mfq ?? [];

  if (document.getElementById(SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.type = "text/javascript";
  script.defer = true;
  script.src = `//cdn.mouseflow.com/projects/${siteId}.js`;
  document.head.appendChild(script);
};

export const removeMouseflow = (window: Window, document: Document) => {
  document.getElementById(SCRIPT_ID)?.remove();
  window._mfq = [];
};

export const setMouseflowVariable = (
  window: Window,
  key: string,
  value: string,
) => {
  window._mfq = window._mfq ?? [];
  window._mfq.push(["setVariable", key, value]);
};
